export const trackerSteps = {
    ACHTransfer: ['InProcess', 'Completed'],
    CanceledSteps: ['Requested', 'Canceled'],
    CheckOrder: ['Ordered', 'Shipped'],
    DebitCardOrder: ['Ordered', 'Shipped', 'Delivered', 'Activated'],
    DebitCardOrderDelayed: [
        'Ordered',
        'Shipped',
        'Delivery delayed',
        'Activated',
    ],
    DebitCardOrderCanceled: ['Ordered', 'Shipped', 'Delivery unsuccessful'],
    InternalTransfers: ['Processing', 'Posted'],
    WireTransfer: ['Requested', 'Reviewing', 'Processing', 'Sent'],
};
export const trackerStatuses = {
    ordered: ['Confirmed', 'InProcess', 'Ordered'],
    success: ['Sent', 'Completed', 'Shipped', 'Posted', 'Activated'],
};
export const SERVER_TIMEZONE = 'America/New_York';
//# sourceMappingURL=constants.js.map